<template>
  <div :class="{ 'fade-out': isFadeOut }" class="wrapper">
    <div class="container fade-in-bg" id="main_page">
      <img src="@/assets/images/illustration_box.png" alt="" class="boxImage">
      <div class="textbox" :class="{ en: this.currentLanguage === 'en' }">
        <div class="textbox-btn">{{ this.getTexts().btntext }}</div>
        <h3></h3>
        <!-- 手機定位及相機權限開啟 -->
        <div class="notice-item">
          <div class="notice-icon">
            <img src="@/assets/images/illustration_icon2.png" alt="" class="iconImage">
          </div>
          <div class="notice-text">
            <p v-html="this.getTexts().gpstext"></p>
          </div>
        </div>
        <!-- 環境辨識 -->
        <div class="notice-item">
          <div class="notice-icon">
            <img src="@/assets/images/illustration_icon3.png" alt="" class="iconImage">
          </div>
          <div class="notice-text">
            <p v-html="this.getTexts().scanobjtext"></p>
          </div>
        </div>
        <!-- 掃描操作指引 -->
        <div class="notice-item">
          <div class="notice-icon">
            <img src="@/assets/images/illustration_icon5.png" alt="" class="iconImage">
          </div>
          <div class="notice-text">
            <p v-html="this.getTexts().instructionetext"></p>
          </div>
        </div>
        <!-- 環境安全 -->
        <div class="notice-item">
          <div class="notice-icon">
            <img src="@/assets/images/illustration_icon6.png" alt="" class="iconImage">
          </div>
          <div class="notice-text">
            <p v-html="this.getTexts().enviromenttext"></p>
          </div>
        </div>
        <!-- 手機規格 -->
        <div class="notice-item">
          <div class="notice-icon">
            <img src="@/assets/images/illustration_icon4.png" alt="" class="iconImage">
          </div>
          <div class="notice-text">
            <p v-html="this.getTexts().devicetext"></p>
          </div>
        </div>
      </div>
      <div class="lightboxBtn" @click="goNext('ar')">
        <span :class="{ en: this.currentLanguage === 'en' }">{{ this.getTexts().startbtntext }}</span>
        <img src="@/assets/images/button-cover02.png" alt="">
      </div>
      <div style="height: 50px;"></div>
    </div>

    <div class="container fade-in-bg" id="browser">
      <img src="@/assets/images/illustration_box.png" alt="" class="boxImage">
      <img src="@/assets/images/illustration_icon0.png" alt="" class="lightboxIconImage">
      <div class="lightbox-GPS">
        <h1>{{ this.getTexts().lightboxBrowserText }}</h1>
        <p v-html="this.getTexts().lightboxBrowserContent"></p>
        <div class="lightboxBtn" @click="goNext('gps')">
          <span :class="{ en: this.currentLanguage === 'en' }">{{ this.getTexts().startbtntext }}</span>
          <img src="@/assets/images/button-cover02.png" alt="">
        </div>
      </div>
      <div style="height: 50px;"></div>
    </div>

    <div class="container fade-in-bg" id="gps">
      <img src="@/assets/images/illustration_box.png" alt="" class="boxImage">
      <img src="@/assets/images/illustration_icon1.png" alt="" class="lightboxIconImage">
      <div class="lightbox-GPS">
        <h1>{{ this.getTexts().lightboxGPSText }}</h1>
        <p>{{ this.getTexts().lightboxGPSContent }}</p>
        <div class="lightboxBtn" @click="goNext('camera')">
          <span :class="{ en: this.currentLanguage === 'en' }">{{ this.getTexts().startbtntext }}</span>
          <img src="@/assets/images/button-cover02.png" alt="">
        </div>
      </div>
      <div style="height: 50px;"></div>
    </div>

    <div class="container fade-in-bg" id="camera">
      <img src="@/assets/images/illustration_box.png" alt="" class="boxImage">
      <img src="@/assets/images/illustration_icon3.png" alt="" class="lightboxIconImage">
      <div class="lightbox-GPS">
        <h1>{{ this.getTexts().lightboxCameraText }}</h1>
        <p>{{ this.getTexts().lightboxCameraContent }}</p>
        <div class="lightboxBtn" @click="goNext('main')">
          <span :class="{ en: this.currentLanguage === 'en' }">{{ this.getTexts().startbtntext }}</span>
          <img src="@/assets/images/button-cover02.png" alt="">
        </div>
      </div>
      <div style="height: 50px;"></div>
    </div>
    <div style="height: 50px;"></div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  name: 'Illustration',
  data() {
    return {
      isFadeOut: false,
      languageTexts: {
        zh: {
          btntext: '注意事項',
          titletext: '為了確保您有最佳的 AR 體驗，下列幾點請務必留意：',
          gpstext: '手機定位及相機權限開啟：<br>請先開啟您手機的定位服務及相機鏡頭權限，AR 功能才能正常啟動。',
          scanobjtext: '掃描操作指引：<br>正確掃描方式請將鏡頭穩定地對準指定植物的辨識範圍。',
          instructionetext: '環境辨識：<br>請將鏡頭左右掃描，以利系統進行多方位環境辨識，加速 AR 內容的載入。',
          enviromenttext: '環境安全：<br>園區內的道路可能存在高低落差，請您在體驗過程中務必留意腳步，確保自身安全。',
          devicetext: '手機規格：<br>建議手機規格在iPhone X 且版本為ios 15 及 Android 9.0 以上，才能確保最佳體驗效果。',
          startbtntext: '下一步',
          lightboxGPSText: '手機GPS定位權限開啟',
          lightboxGPSContent: '請開啟GPS定位功能，讓 AR 故事能準確出現在您腳下的土地。',
          lightboxCameraText: '相機權限開啟',
          lightboxCameraContent: '請開啟相機功能，我們才能將 AR 驚喜「放進」您的世界裡。',
          lightboxBrowserText: '選擇瀏覽器',
          lightboxBrowserContent: '建議以手機原生瀏覽器開啟網頁，iPhone可選擇Safari或Chrome，Android手機可選擇Chrome。<br>三星手機請務必選擇三星原生瀏覽器「三星網際網路」，避免相機畫面變形，容易造成辨識困難。',
        },
        en: {
          btntext: 'Important Notes:',
          titletext: 'To ensure the best AR experience, please keep the following in mind:',
          gpstext: 'Enable Location and Camera Access：<br>Please turn on your phone’s location services and allow camera access. These permissions are required for the AR functions to operate properly.',
          scanobjtext: 'Scanning Instructions:<br>Hold your phone steady and aim the camera at the designated plant area for accurate scanning.',
          instructionetext: 'Environmental Recognition: <br>Move your camera slowly from side to side to help the system recognize the surroundings from multiple angles and load the AR content more quickly.',
          enviromenttext: 'Safety Awareness:<br>Some pathways in the park may have uneven surfaces or changes in elevation. Please watch your step and stay aware of your surroundings during the AR experience.',
          devicetext: 'Device Requirements:<br>For optimal performance, we recommend using:<br>•iPhone X or later with iOS 15 or above<br>•Android devices running version 9.0 or above',
          startbtntext: 'Next',
          lightboxGPSText: 'Enable Mobile GPS Location Permissions',
          lightboxGPSContent: 'Please enable GPS location services so that the AR story can accurately appear on the land beneath your feet.',
          lightboxCameraText: 'Enable Camera Permissions',
          lightboxCameraContent: 'Please enable camera access so we can "place" AR surprises into your world.',
          lightboxBrowserText: 'Select Browser',
          lightboxBrowserContent: 'We recommend using your phone’s native browser. For iPhone, please use Safari or Chrome. For Android, please use Chrome.<br>For Samsung users, please ensure you use the native "Samsung Internet" browser to avoid camera distortion, which may cause recognition failure.'
        },
      },
    }
  },
  computed: {
    currentLanguage() {
      return Cookies.get('lang') || 'zh'
    }
  },
  methods: {
    getTexts() {
      return this.languageTexts[this.currentLanguage] || this.languageTexts.zh
    },
    async goNext(permissionType) {
      // 檢查地理位置權限
      if (permissionType === 'camera') {
        if (!navigator.geolocation) {
          alert(this.currentLanguage === 'en'
            ? 'Your device does not support geolocation.'
            : '您的裝置不支援地理定位功能。');
          return;
        }

        try {
          // 檢查權限狀態
          if (navigator.permissions) {
            const permissionStatus = await navigator.permissions.query({ name: 'geolocation' });

            if (permissionStatus.state === 'denied') {
              alert(this.currentLanguage === 'en'
                ? 'Location permission is denied. Please enable location services in your device settings.'
                : '定位權限已被拒絕。請在您的裝置設定中開啟定位服務。');
              return;
            }
          }

          // 嘗試獲取位置
          navigator.geolocation.getCurrentPosition(
            (position) => {
              // 成功獲取位置，繼續導頁
              $("#gps").fadeOut(500);
              setTimeout(() => {
                $("#camera").fadeIn(500);
              }, 500)
            },
            (error) => {
              // 獲取位置失敗
              let errorMessage = '';
              switch (error.code) {
                case error.PERMISSION_DENIED:
                  errorMessage = this.currentLanguage === 'en'
                    ? 'Location permission denied. Please enable location services and reload page to continue.'
                    : '定位權限被拒絕。請開啟定位服務後重新整理以繼續使用。';
                  break;
                case error.POSITION_UNAVAILABLE:
                  errorMessage = this.currentLanguage === 'en'
                    ? 'Location information is unavailable.'
                    : '無法取得位置資訊。';
                  break;
                case error.TIMEOUT:
                  errorMessage = this.currentLanguage === 'en'
                    ? 'Location request timed out.'
                    : '定位請求逾時。';
                  break;
                default:
                  errorMessage = this.currentLanguage === 'en'
                    ? 'An unknown error occurred.'
                    : '發生未知錯誤。';
              }
              alert(errorMessage);
            },
            {
              enableHighAccuracy: true,
              timeout: 10000,
              maximumAge: 0
            }
          );
        } catch (error) {
          console.error('GPS 檢查錯誤:', error);
          alert(this.currentLanguage === 'en'
            ? 'Unable to check location permission.'
            : '無法檢查定位權限。');
        }
      }
      else if (permissionType === 'main') {
        // 檢查相機權限
        try {
          // 嘗試請求相機權限
          const stream = await navigator.mediaDevices.getUserMedia({
            video: true
          });

          // 成功取得相機權限，停止串流
          stream.getTracks().forEach(track => track.stop());
          console.log('相機權限已開啟');

          // 切換頁面
          $("#camera").fadeOut(500);
          setTimeout(() => {
            $("#main_page").fadeIn(500);
          }, 500);

        } catch (error) {
          console.error('相機權限錯誤:', error);
          let errorMessage = '';

          if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
            errorMessage = this.currentLanguage === 'en'
              ? 'Camera permission denied. Please enable camera access in your device settings and reload page.'
              : '相機權限被拒絕。請在您的裝置設定中開啟相機權限後重新整理。';
          } else if (error.name === 'NotFoundError') {
            errorMessage = this.currentLanguage === 'en'
              ? 'No camera found on this device.'
              : '在此裝置上找不到相機。';
          } else if (error.name === 'NotReadableError') {
            errorMessage = this.currentLanguage === 'en'
              ? 'Camera is already in use by another application.'
              : '相機已被其他應用程式使用中。';
          } else {
            errorMessage = this.currentLanguage === 'en'
              ? 'Unable to access camera. Please check your permissions.'
              : '無法存取相機。請檢查您的權限設定。';
          }

          alert(errorMessage);
        }
      }
      else if(permissionType == 'gps'){
        $("#browser").fadeOut(function() {
          $("#gps").fadeIn(500);
        });
      }
      else {
        $("#main_page").fadeOut(500);
        setTimeout(() => {
          this.isFadeOut = true
          this.$router.push({ name: 'Map' })
        }, 500)
      }

    }
  }
}
</script>
<style scoped>
body {
  overflow: scroll !important;
}
.wrapper {
  padding-top: 10%;
  min-height: 100vh;
}

#camera,
#gps,
#main_page {
  display: none;
}

.lightbox-GPS h1 {
  font-size: 1.7rem;
  font-weight: 700;
  color: black;
  text-align: center;
  margin-bottom: 2vh;
}

.lightbox-GPS p {
  font-size: 1.3rem;
  color: #333333;
  text-align: left;
  line-height: 1.5;
  margin: 0 5%;
}

.lightboxIconImage {
  width: 35%;
  margin: 2rem;
}

.lightboxBtn {
  font-size: 1.5rem;
  color: white;
  background-color: rgba(153, 153, 153, 0.7);
  width: 50%;
  max-width: 187px;
  margin: 2vh auto 0 auto;
  border-radius: 40px;
  border: 1px solid white;
  letter-spacing: 6px;
  padding: 6px;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  transition: all 0.3s ease;
  /* 發光效果 */
  box-shadow:
    0 0 20px rgba(255, 255, 255, 0.3),
    0 0 40px rgba(67, 106, 178, 0.2),
    inset 0 0 20px rgba(255, 255, 255, 0.1);

  /* 發光動畫 */
  animation: pulse-glow 2s ease-in-out infinite alternate;
}

.lightboxBtn .en {
  font-size: 1.3rem;
  letter-spacing: 0px;
}

.lightboxBtn img {
  position: absolute;
  left: -5%;
  top: -5%;
  width: 110%;
  height: 110%;
  z-index: 1000;
  pointer-events: none;
}

.container {
  text-align: center;
  width: 80%;
  margin: 0 auto;
  color: white;
  border-radius: 25px;
  border: 2px solid rgba(255, 255, 255, 0.1);
  position: relative;
  overflow: hidden;
  background-color: rgba(255, 255, 255, 0.4);
}

.container .boxImage {
  position: absolute;
  width: 120%;
  height: 120%;
  top: -10%;
  left: -10%;
  z-index: -1;
  opacity: 0.3;
}

.container .textbox {
  text-align: left;
  margin: 2% auto 0% auto;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  border-radius: 25px;
  padding: 0.5rem;
  overflow: hidden;
  position: relative;
  letter-spacing: 1px;
  padding-bottom: 0px;
}

.container .en {
  letter-spacing: 0px;
}

.container .textbox p {
  margin: 5px 0px;
}

.container .textbox .textbox-btn {
  width: fit-content;
  margin: 1% auto;
  padding: 4px 10px;
  background-color: #436ab2;
  border-radius: 40px;
  font-size: 1.7rem;
  font-weight: 600;
  color: #ffffff;
  text-align: center;
  letter-spacing: 2px;
  padding: 1rem 2rem;
  line-height: 1.5;
}

.container .bottom_text {
  font-size: 1rem;
  letter-spacing: 2px;
  color: #6a3906;
  font-weight: 600;
  text-align: center;
  padding: 4% 0px;
  line-height: 1.6rem;
}

.fade-in-bg {
  opacity: 0;
  animation: fadeIn 0.5s forwards;
}

.bounce-animation {
  animation: bounce 2s infinite ease-in-out;
}

.fade-out {
  animation: fadeOut 0.5s forwards;
}

.notice-item {
  display: flex;
  align-items: center;
  margin-bottom: 3%;
  width: 100%;
}

.notice-icon {
  width: 18%;
  margin-right: 10px;
}

.notice-icon .iconImage {
  width: 100%;
}

.notice-text {
  width: 80%;
}

.notice-text p {
  font-size: 1.1rem;
  line-height: 1.5;
  margin: 0;
}

@keyframes bounce {

  0%,
  100% {
    transform: translate(-50%, 0px) rotate(0deg);
  }

  25% {
    transform: translate(-50%, -5px) rotate(2deg);
  }

  50% {
    transform: translate(-50%, 0px) rotate(0deg);
  }

  75% {
    transform: translate(-50%, -5px) rotate(-2deg);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

@keyframes pulse-glow {

  0%,
  100% {
    box-shadow:
      0 0 20px rgba(255, 255, 255, 0.3),
      0 0 40px rgba(67, 106, 178, 0.2);
    transform: scale(1);
  }

  50% {
    box-shadow:
      0 0 40px rgba(255, 255, 255, 0.7),
      0 0 80px rgba(67, 106, 178, 0.5),
      0 0 120px rgba(67, 106, 178, 0.3);
    transform: scale(1.02);
  }
}

/* Tablet 響應式設計 (768px - 1024px) */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  h1 {
    margin-top: 2vh;
  }

  .container {
    width: 80%;
    margin-top: 3vh;
  }

  .container .textbox {
    font-size: 2rem;
    line-height: 2.7rem;
    padding: 1rem;
  }

  .container .textbox .textbox-btn {
    font-size: 2.5rem;
    padding: 1rem 2rem;
    margin: 2% auto;
  }

  .lightboxIconImage {
    width: 20%;
    margin: 1rem;
  }

  .notice-icon {
    width: 15%;
    margin-right: 15px;
  }

  .notice-text p {
    font-size: 2rem;
    line-height: 1.5;
  }

  .lightbox-GPS h1 {
    font-size: 2.5rem;
    margin-bottom: 2vh;
  }

  .lightbox-GPS p {
    font-size: 2rem;
  }

  .lightboxBtn {
    font-size: 2.5rem;
    border-radius: 50px;
    max-width: 300px;
    padding: 2% 5%;
  }
}

/* Large Tablet 響應式設計 (1025px - 1366px) */
@media screen and (min-width: 1025px) and (max-width: 1366px) {
  h1 {
    font-size: 4rem;
    margin-top: 2vh;
  }

  .container {
    width: 80%;
    margin-top: 4vh;
  }

  .container .textbox {
    font-size: 2.5rem;
    line-height: 1.5;
    padding: 1.5rem;
  }

  .container .textbox .textbox-btn {
    font-size: 3rem;
    padding: 8px 20px;
  }

  .lightboxIconImage {
    width: 20%;
    margin: 1rem;
  }

  .notice-icon {
    width: 12%;
    margin-right: 15px;
  }

  .notice-text p {
    font-size: 2.5rem;
    line-height: 1.5;
  }

  .lightbox-GPS h1 {
    font-size: 3rem;
    margin-bottom: 2vh;
  }

  .lightbox-GPS p {
    font-size: 2.5rem;
  }

  .lightboxBtn {
    font-size: 3rem;
    border-radius: 50px;
    max-width: 300px;
    padding: 2% 5%;
  }
}

/* Landscape Tablet 響應式設計 */
@media screen and (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  h1 {
    font-size: 3rem;
    margin-top: 2vh;
  }

  .container {
    width: 65%;
    margin-top: 2vh;
  }

  .container .textbox {
    font-size: 15px;
    line-height: 22px;
  }

}
</style>
